<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "views-collaborator-backoffice-affiliates",

  watch: {
    $route(val) {
      if (val.name == "CollaboratorAffiliates") {
        console.log("Entrei no index de extrato e cpa")
        // this.$router
        //   .push({
        //     name: "CollaboratorOnlineExtract",
        //   })
        //   .catch(() => {});
      }
    },
  },
};
</script>
